export default "__VITE_ASSET__da859720__"